import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbySeo } from 'gatsby-plugin-next-seo'
import { Helmet } from 'react-helmet'

// Icon
import favicon from 'img/favicon.png'

const removeHTML = (content) => {
  let newContent = content

  if (typeof document !== 'undefined') {
    const titleHtml = newContent
    const div = document.createElement('div')
    div.innerHTML = titleHtml
    newContent = div.innerText
  }

  return newContent
}

const SEO = ({ seo, socialImage }) => {
  const {
    site,
    wpComponent,
    // eslint-disable-next-line
  } = useStaticQuery(graphql`
    query socialSharingQuery {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)

  const defaultImageUrl = socialImage
    ? {
      url: `${site.siteMetadata.siteUrl}${socialImage}`,
    }
    : ''

  const image = defaultImageUrl

  return (
    <>
      <GatsbySeo
        language="nl"
        title={removeHTML(seo.title) || ''}
        description={removeHTML(seo.metaDesc) || ''}
        canonical={seo.canonical || ''}
        openGraph={{
          type: seo.opengraphTitle || '',
          url: seo.opengraphUrl || '',
          title: removeHTML(seo.title) || '',
          description: removeHTML(seo.metaDesc) || '',
          images: [image],
        }}
      />
      <Helmet>
        <script
          id="Cookiebot"
          src="https://consent.cookiebot.com/uc.js"
          data-cbid="1a2cdf8b-69d4-4cb5-8589-e814108d69c4"
          type="text/javascript"
          async
        />
      </Helmet>
    </>
  )
}

export default SEO
